import Cookies from '@mentimeter/cookies';

export const getUITheme = () => {
  const developmentFlags = Cookies.get('DEVELOPMENT_FLAGS');
  const uiThemeOverride = JSON.parse(developmentFlags || '{}')[
    'ui-theme-override'
  ];

  const uiThemeSetting = Cookies.get('ui-theme');

  return uiThemeOverride || uiThemeSetting || 'light';
};
